import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Route} from "../../models/route";
import {RouteService} from "../../services/route/route.service";
import {MessagesService} from "../../services/messages/messages.service";

@Component({
    selector: 'app-route-modal',
    templateUrl: './route-modal.component.html',
    styleUrls: ['./route-modal.component.scss']
})
export class RouteModal implements OnInit {

    @Input() projectId: string;
    @Input() databaseId: string;
    @Input() route: Route;
    @Input() routesLength: number;

    routeForm: FormGroup;
    routeFormIsSubmitted: boolean = false;

    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: FormBuilder,
        private messagesService: MessagesService,
        private routesService: RouteService,
    ) {
    }

    ngOnInit() {
        this.routeForm = this.formBuilder.group({
            name: [this.route ? this.route.name || '' : '', [Validators.required]],
            color: [this.route ? this.route.color || '' : '', [Validators.required]],
        });
    }

    submitRouteForm() {
        this.routeFormIsSubmitted = true;

        if (this.routeForm.invalid) return;

        const route = new Route({
            name : this.routeForm.controls.name.value,
            color : this.routeForm.controls.color.value,
        });

        this.routesService.postRoute(this.projectId, this.databaseId, route)
            .subscribe(
                () => this.messagesService.successToast('Route created.'),
                err => this.messagesService.errorToast(err),
                () => this.activeModal.close(false)
            );
    }
}
